import type { MediaItem } from "@/types/content";

export const mediaItems: MediaItem[] = [
  {
    id: "interstellar-echo",
    title: "星际回声",
    type: "movie",
    year: 2025,
    region: "内地",
    genres: ["科幻", "冒险"],
    rating: 9.1,
    duration: "142 分钟",
    director: "陆沉",
    cast: ["周牧", "林知夏", "陈砚", "高野"],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20artwork%2C%20lone%20astronaut%20silhouette%20before%20a%20colossal%20glowing%20ringed%20planet%2C%20deep%20navy%20space%20backdrop%20with%20warm%20amber%20rim%20light%2C%20dramatic%20volumetric%20fog%2C%20minimal%20elegant%20composition%20without%20text%2C%20high%20detail%20vertical%20poster&width=600&height=900&seq=tm-poster-interstellar&orientation=portrait",
    tagline: "宇宙给出的回答，藏在四十年前的一段回声里。",
    summary:
      "深空监听员在一次例行巡检中收到一段来自四十年前的求救信号，追查之下却发现信号源指向自己从未谋面的父亲。",
    synopsis: [
      "公元 2078 年，深空监听站「回声一号」漂浮在土星轨道之外。值守员宋其在一次例行巡检中捕获了一段微弱的窄带信号——它有着四十年前的加密格式，内容只有一句话：不要回头。",
      "为了验证信号的来源，宋其违背指令启动旧型跃迁舱，沿着残留的航迹一路追進人类早期航天的禁区。在那里，他找到了父亲失联的飞船，也找到了那段回声真正的收件人。影片以极简的对白和大量静默场面，讨论记忆、传承与人类在宇宙尺度下的孤独。",
    ],
    hot: 98,
    updated: "2025-10-12",
  },
  {
    id: "long-night-coming",
    title: "长夜将至",
    type: "movie",
    year: 2024,
    region: "港台",
    genres: ["犯罪", "悬疑"],
    rating: 8.6,
    duration: "118 分钟",
    director: "麦启明",
    cast: ["张宗翰", "余曼", "何启南"],
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%20artwork%2C%20rain%20slicked%20neon%20city%20street%20at%20midnight%2C%20silhouette%20of%20a%20detective%20in%20a%20long%20coat%2C%20deep%20blue%20shadows%20with%20warm%20orange%20street%20lamp%20glow%2C%20cinematic%20contrast%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-longnight&orientation=portrait",
    tagline: "天亮之前，每个人都要做出选择。",
    summary:
      "一位即将退休的老刑警，在最后一班岗上接到一桩看似普通的失踪案，却牵出横跨十二年的旧案。",
    synopsis: [
      "暴雨夜，湾城警署接到报案：一名中学教师在放学后失踪。距离退休只剩三天的老刑警周邦彦接手案件，原本以为只是一次普通的寻人，却在失踪者的储物柜里发现了一盘标注着十二年前日期的录音带。",
      "随着调查深入，旧案中的证人一个个改口，警署内部的关系网逐渐浮出水面。周邦彦必须在天亮之前决定，是守往日的规矩，还是把真相交出去。影片以冷静克制的调度，拍出了一个城市在长夜里的呼吸。",
    ],
    hot: 93,
    updated: "2025-09-28",
  },
  {
    id: "between-mountains-seas",
    title: "山海之间",
    type: "movie",
    year: 2025,
    region: "内地",
    genres: ["奇幻", "冒险"],
    rating: 8.4,
    duration: "135 分钟",
    director: "白泽宇",
    cast: ["林知夏", "顾清让", "沈鹿", "段溪"],
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20movie%20poster%20artwork%2C%20misty%20jade%20mountains%20and%20a%20lone%20traveler%20on%20a%20cliff%20path%2C%20floating%20ancient%20temple%20in%20the%20clouds%2C%20teal%20mist%20with%20warm%20golden%20sunrise%2C%20painterly%20cinematic%20style%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-mountainsea&orientation=portrait",
    tagline: "山的那边是海，海的尽头是故乡。",
    summary:
      "少年为寻找失踪的绘图师父亲，带着一张残缺的山海图走进传说中会移动的群山。",
    synopsis: [
      "在山海交界的小城，绘图师的后代阿栖守着父亲留下的半张地图。传说中，群山会在特定的年份移动一次，而移动的路径只能在完整的山海图上读到。",
      "为了补全地图，阿栖与守山人的女儿一道深入云雾。他们遇见了以记忆为食的异兽，也遇见了被困在山中三百年的旧神。影片用大量实景与手绘质感结合的画面，讲述一个有关于告别与归途的东方奇幻故事。",
    ],
    hot: 95,
    updated: "2025-10-08",
  },
  {
    id: "light-chaser",
    title: "逐光者",
    type: "movie",
    year: 2023,
    region: "内地",
    genres: ["剧情", "传记"],
    rating: 8.9,
    duration: "126 分钟",
    director: "苏晚",
    cast: ["陈砚", "余曼", "高野"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20human%20drama%20film%20poster%20artwork%2C%20young%20filmmaker%20holding%20a%20vintage%20camera%20in%20a%20sunlit%20dusty%20studio%2C%20dust%20motes%20in%20golden%20light%2C%20muted%20navy%20shadows%2C%20tender%20cinematic%20mood%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-lightchaser&orientation=portrait",
    tagline: "不是每一束光都能被看见，但总有人在追。",
    summary:
      "上世纪八十年代，一位县城放映员用一台旧摄影机，记录下整座小城最后的胶片岁月。",
    synopsis: [
      "1986 年，县城电影院即将被改造成录像厅。放映员老莫偷偷留下了一台报废的摄影机，开始拍摄他熟悉的人和街道：修鞋的、卖豆腐的、准备外出打工的年轻人。",
      "三十多年后，这些胶片在旧仓库里被发现，成为一座小城唯一的影像档案。影片根据真实事件改编，用缓慢而克制的镜头语言，讲述一个人如何用最笨拙的方式对抗遗忘。",
    ],
    hot: 88,
    updated: "2025-08-20",
  },
  {
    id: "south-of-snowline",
    title: "雪线以南",
    type: "movie",
    year: 2024,
    region: "内地",
    genres: ["战争", "剧情"],
    rating: 8.2,
    duration: "148 分钟",
    director: "韩牧川",
    cast: ["张宗翰", "段溪", "沈鹿"],
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20war%20drama%20film%20poster%20artwork%2C%20snow%20covered%20mountain%20pass%20with%20a%20small%20group%20of%20soldiers%20marching%2C%20cold%20steel%20blue%20tones%20with%20a%20single%20warm%20lantern%20glow%2C%20atmospheric%20fog%2C%20cinematic%20realism%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-snowline&orientation=portrait",
    tagline: "他们翻过的那座山，后来长满了树。",
    summary:
      "一支负责运送电台的小分队，在雪线之上与大部队失联，十四天里他们只剩下彼此和三天的口粮。",
    synopsis: [
      "1944 年冬，一支七人小分队奉命将一部电台送过雪线。暴风雪中他们与主力失去联系，地图被雪水浸透，方向只剩下一句口口相传的描述：翻过山口，向南就是驻地。",
      "影片没有正面战场，全部篇幅都留给行军、等待与沉默的对话。当最后一名士兵把电台交到接应者手里，观众才明白他们究竟护送的是什么。结尾一组长达三分钟的空镜，成为近年华语战争片最克制的表达。",
    ],
    hot: 84,
    updated: "2025-07-16",
  },
  {
    id: "train-number-seven",
    title: "第七号列车",
    type: "movie",
    year: 2025,
    region: "欧美",
    genres: ["悬疑", "惊悚"],
    rating: 7.9,
    duration: "110 分钟",
    director: "Elias Ford",
    cast: ["Nora Vale", "Julian Reeve", "Marta Klein"],
    poster:
      "https://readdy.ai/api/search-image?query=Suspense%20mystery%20film%20poster%20artwork%2C%20vintage%20night%20train%20speeding%20through%20a%20dark%20forest%2C%20one%20lit%20window%2C%20swirling%20fog%20and%20cold%20moonlight%2C%20deep%20navy%20palette%20with%20amber%20highlights%2C%20cinematic%20tension%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-trainseven&orientation=portrait",
    tagline: "这趟车没有终点站，只有不断重复的午夜。",
    summary:
      "一列驶向北方的夜车上，七名乘客发现自己被困在同一段十二分钟的时间里。",
    synopsis: [
      "午夜零点七分，第七号列车驶入一条隧道后，所有时钟停在了同一秒。列车员消失，餐车里的咖啡永远是热的，而窗外的雪景每十二分钟重复一次。",
      "七名互不相识的乘客必须找出这趟列车为什么留下他们。随着一次次循环，每个人隐瞒的往事被逐一摊开。影片用封闭空间与精密的时间结构，完成了一次关于愧疚的推理。",
    ],
    hot: 90,
    updated: "2025-10-01",
  },
  {
    id: "desert-rose",
    title: "沙漠玫瑰",
    type: "movie",
    year: 2022,
    region: "内地",
    genres: ["爱情", "剧情"],
    rating: 7.6,
    duration: "104 分钟",
    director: "沈青禾",
    cast: ["余曼", "顾清让", "白露"],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20poster%20artwork%2C%20woman%20in%20a%20flowing%20ochre%20dress%20standing%20in%20vast%20desert%20dunes%20at%20sunset%2C%20warm%20orange%20sky%20fading%20into%20deep%20indigo%2C%20soft%20windblown%20sand%2C%20cinematic%20elegance%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-desertrose&orientation=portrait",
    tagline: "有些花开在没有人经过的地方。",
    summary:
      "植物学家在西北戈壁驻站的三个月里，与当地气象员共同守护一片即将消失的野生玫瑰。",
    synopsis: [
      "为了完成一份濒危植物名录，植物学家沈知白来到戈壁深处的气象站。这里只有一名值守了六年的气象员，和一片每年只开七天的野生玫瑰。",
      "两个习惯独处的人在风沙与星空之间慢慢靠近，却在玫瑰盛开的最后一天面临分别。影片用大量的自然光与长镜头，把一段没有承诺的感情拍得干净又克制。",
    ],
    hot: 76,
    updated: "2025-06-11",
  },
  {
    id: "city-edge",
    title: "城市边缘",
    type: "movie",
    year: 2023,
    region: "港台",
    genres: ["犯罪", "剧情"],
    rating: 8.1,
    duration: "121 分钟",
    director: "麦启明",
    cast: ["何启南", "张宗翰", "苏梨"],
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20social%20drama%20film%20poster%20artwork%2C%20aerial%20view%20of%20a%20dense%20city%20block%20at%20dusk%2C%20single%20lit%20rooftop%20water%20tank%2C%20deep%20blue%20city%20shadows%20and%20warm%20window%20lights%2C%20gritty%20cinematic%20texture%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-cityedge&orientation=portrait",
    tagline: "城市的边缘，住着城市的心脏。",
    summary:
      "一栋即将拆迁的老楼里，六户人家在最后三十天里各自盘算着未来。",
    synopsis: [
      "旧区重建公告贴出的那天，福昌楼的六户人家同时收到了搬迁通知。楼下的修车铺、三楼的裁缝店、顶楼的天台菜园，都将在三十天后消失。",
      "影片以近乎纪录片的视角，跟随六户人家度过最后的三十天。有人想多要一笔补偿，有人只想把父亲的牌位带走。当推土机到来时，观众已经认识了这栋楼里的每一盏灯。",
    ],
    hot: 81,
    updated: "2025-05-22",
  },
  {
    id: "dark-tide-city",
    title: "暗涌之城",
    type: "tv",
    year: 2025,
    region: "港台",
    genres: ["犯罪", "悬疑"],
    rating: 9.0,
    duration: "45 分钟 / 集",
    episodes: "24 集",
    director: "陈立行",
    cast: ["张宗翰", "苏梨", "何启南", "林知夏"],
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20series%20poster%20artwork%2C%20harbor%20city%20skyline%20at%20night%20with%20container%20cranes%2C%20two%20silhouetted%20figures%20on%20a%20pier%2C%20deep%20navy%20blue%20with%20amber%20port%20lights%2C%20moody%20cinematic%20atmosphere%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-darktide&orientation=portrait",
    tagline: "潮水退去之后，才知道谁一直站在水里。",
    summary:
      "港口城市连环失踪案背后，是一张盘踞二十年的航运网络。新调任的刑警队长必须在潮水退去前找到证据。",
    synopsis: [
      "港城连续发生三起船员失踪案，报案记录却都显示「已自行离船」。刚从内地调任的刑警队长沈砚接手案件，发现所有线索都指向本地最大的航运家族。",
      "随着调查推进，警队内部、码头工会与航运公司之间错综的利益关系逐渐显形。全剧以港口潮汐为章节节点，24 集讲完一场没有硝烟的围猎。",
    ],
    hot: 99,
    updated: "2025-10-14",
  },
  {
    id: "spring-chronicle",
    title: "春日纪事",
    type: "tv",
    year: 2025,
    region: "内地",
    genres: ["爱情", "生活"],
    rating: 8.7,
    duration: "42 分钟 / 集",
    episodes: "20 集",
    director: "苏晚",
    cast: ["林知夏", "顾清让", "白露"],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20series%20poster%20artwork%2C%20sunlit%20courtyard%20with%20blooming%20cherry%20blossoms%20and%20old%20wooden%20windows%2C%20soft%20golden%20light%20and%20pale%20blue%20sky%2C%20gentle%20nostalgic%20mood%2C%20painterly%20cinematic%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-spring&orientation=portrait",
    tagline: "小院里的春天，来得比别人晚一点。",
    summary:
      "南方小城的一座老院子里，三户人家在同一个春天里各自经历告别与重逢。",
    synopsis: [
      "老院子要改造的消息传来时，院里的樱花刚好开了。独居的退休教师、刚辞职回家的年轻人、以及一对准备搬走的小夫妻，在同一个春天里被迫重新打量自己的生活。",
      "全剧没有强情节，靠一日三餐、晾晒的被子与邻里间的短对话推进。导演苏晚用大量自然光和空镜，把一个普通春天拍得让人想回家。",
    ],
    hot: 92,
    updated: "2025-10-05",
  },
  {
    id: "cloud-archive",
    title: "云上档案",
    type: "tv",
    year: 2024,
    region: "内地",
    genres: ["科幻", "悬疑"],
    rating: 8.3,
    duration: "48 分钟 / 集",
    episodes: "16 集",
    director: "白泽宇",
    cast: ["周牧", "沈鹿", "陈砚"],
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20series%20poster%20artwork%2C%20floating%20data%20archive%20tower%20above%20the%20clouds%2C%20glowing%20amber%20circuitry%20patterns%20against%20deep%20navy%20sky%2C%20futuristic%20minimal%20composition%2C%20cinematic%20scale%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-cloudarchive&orientation=portrait",
    tagline: "所有被删除的记忆，都在云层之上等着被读取。",
    summary:
      "记忆可以上传的年代，一名档案管理员发现自己的过去被人为删除了一整年。",
    synopsis: [
      "在记忆云服务普及的年代，档案管理员程雾负责为逝者整理遗留记忆。一次例行归档中，他读到了一段属于自己的画面——而这段记忆在他的档案里根本不存在。",
      "为了找回缺失的一年，程雾开始违规访问云层之上的封存区。剧集以单元案件推进，每个案件都指向同一个问题：当记忆可以被编辑，我们还能确认自己是谁吗。",
    ],
    hot: 87,
    updated: "2025-09-18",
  },
  {
    id: "homeward-train",
    title: "归途列车",
    type: "tv",
    year: 2023,
    region: "内地",
    genres: ["剧情", "家庭"],
    rating: 8.5,
    duration: "40 分钟 / 集",
    episodes: "28 集",
    director: "韩牧川",
    cast: ["段溪", "余曼", "高野"],
    poster:
      "https://readdy.ai/api/search-image?query=Family%20drama%20series%20poster%20artwork%2C%20green%20overnight%20train%20crossing%20vast%20golden%20wheat%20fields%20at%20dusk%2C%20warm%20light%20in%20the%20windows%2C%20nostalgic%20cinematic%20mood%2C%20muted%20palette%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-homeward&orientation=portrait",
    tagline: "每一趟回家的车，都比想象中更长。",
    summary:
      "一对在南方打工的夫妻，用十二年时间往返于故乡与工厂之间，拉扯大两个孩子。",
    synopsis: [
      "从 2008 年到 2020 年，老周和妻子每年只在春节回家一次。剧集以十二次归途为结构，每一次列车上的座位、行李和谈话，都记录着这个家庭的细微变化。",
      "孩子们从期待父母回家，到逐渐无话可说，再到自己坐上同一趟列车外出打工。全剧最后一集，老周独自坐上返程的绿皮车，窗外是已经修好的高铁线路。",
    ],
    hot: 79,
    updated: "2025-04-09",
  },
  {
    id: "white-horse-youth",
    title: "少年白马",
    type: "tv",
    year: 2025,
    region: "内地",
    genres: ["武侠", "古装"],
    rating: 8.8,
    duration: "46 分钟 / 集",
    episodes: "32 集",
    director: "顾长风",
    cast: ["顾清让", "林知夏", "沈鹿", "段溪"],
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20series%20poster%20artwork%2C%20young%20swordsman%20in%20white%20robes%20on%20a%20bamboo%20forest%20ridge%2C%20mist%20and%20falling%20leaves%2C%20ink%20wash%20texture%20with%20warm%20amber%20sunlight%2C%20cinematic%20martial%20arts%20mood%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-whitehorse&orientation=portrait",
    tagline: "剑未出鞘，江湖已老。",
    summary:
      "少年剑客带着一匹白马下山寻师，却在沿途的每一座城里听见关于师父的不同传说。",
    synopsis: [
      "师父失踪那年，谢白十四岁。三年后他带着师父留下的白马下山，只带着一句话：找到真正杀我的人。",
      "一路南下，他在客栈、渡口与山寺里遇见了四个自称认识师父的人，每个人讲述的版本都不一样。剧集以公路结构展开，武戏全部采用实景长镜头，被观众称为近年最「不着急」的武侠剧。",
    ],
    hot: 96,
    updated: "2025-10-11",
  },
  {
    id: "midnight-kitchen",
    title: "深夜食光",
    type: "tv",
    year: 2024,
    region: "日韩",
    genres: ["生活", "美食"],
    rating: 8.0,
    duration: "30 分钟 / 集",
    episodes: "12 集",
    director: "佐藤遥",
    cast: ["松本千夏", "井上航", "林知夏"],
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20food%20drama%20poster%20artwork%2C%20small%20lantern%20lit%20noodle%20stall%20in%20a%20rainy%20alley%2C%20steam%20rising%20from%20bowls%2C%20warm%20amber%20glow%20against%20deep%20navy%20night%2C%20cinematic%20warmth%2C%20no%20text%2C%20vertical%20poster&width=600&height=900&seq=tm-poster-midnightkitchen&orientation=portrait",
    tagline: "深夜十二点，胃比心更诚实。",
    summary:
      "一间只在午夜营业的小面馆，每集接待一位带着心事而来的客人。",
    synopsis: [
      "巷子尽头的面馆没有招牌，只在午夜十二点亮灯。老板娘从不问客人为什么这么晚才来，只问一句：要汤面还是拌面。",
      "十二集，十二位客人：加完班的程序员、刚分手的舞者、准备关店的老裁缝。每集用一碗面收尾，把城市里那些说不出口的情绪，交给热气慢慢化开。",
    ],
    hot: 82,
    updated: "2025-03-30",
  },
];

export const featuredMediaIds = ["interstellar-echo", "dark-tide-city", "white-horse-youth"];

export const heroSlides = [
  {
    id: "hero-1",
    mediaId: "interstellar-echo",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20hero%20banner%2C%20astronaut%20standing%20on%20a%20mirror%20like%20alien%20salt%20flat%20under%20a%20giant%20ringed%20planet%2C%20deep%20navy%20sky%20and%20warm%20amber%20horizon%20glow%2C%20wide%20panoramic%20composition%20with%20dark%20empty%20space%20on%20the%20left%20for%20text%2C%20atmospheric%20fog&width=1920&height=900&seq=tm-hero-interstellar&orientation=landscape",
    kicker: "本月焦点 · 科幻",
    title: "星际回声",
    subtitle: "宇宙给出的回答，藏在四十年前的一段回声里。9.1 分口碑之作正在热映。",
  },
  {
    id: "hero-2",
    mediaId: "dark-tide-city",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20rainy%20harbor%20city%20at%20night%2C%20container%20port%20cranes%20and%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20tones%20with%20amber%20port%20lights%2C%20moody%20fog%2C%20panoramic%20composition%20with%20dark%20negative%20space%20left%20side%20for%20text&width=1920&height=900&seq=tm-hero-darktide&orientation=landscape",
    kicker: "高分剧集 · 悬疑",
    title: "暗涌之城",
    subtitle: "潮水退去之后，才知道谁一直站在水里。24 集全季上线。",
  },
  {
    id: "hero-3",
    mediaId: "white-horse-youth",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20misty%20bamboo%20forest%20ridge%20at%20dawn%2C%20lone%20swordsman%20silhouette%20in%20white%20robes%2C%20ink%20wash%20atmosphere%2C%20cold%20blue%20mist%20and%20warm%20golden%20sunrise%2C%20panoramic%20composition%20with%20dark%20negative%20space%20for%20headline&width=1920&height=900&seq=tm-hero-whitehorse&orientation=landscape",
    kicker: "武侠新作 · 古装",
    title: "少年白马",
    subtitle: "剑未出鞘，江湖已老。今秋最受期待的华语武侠剧集。",
  },
];